import { getCalendarCloudSettingsStore } from '../store/store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

const DEFAULT_SHOULD_EVENT_END_EARLY_FALLBACK = false;

/**
 * Gets the effective value for the end events early option
 */
export const getEffectiveShouldEventsEndEarly = (): boolean => {
    if (!isMiniFeatureEnabled('mini-cal-speedyMeetingsSetting')) {
        return false;
    }

    const { shouldEventsEndEarly } = getCalendarCloudSettingsStore();
    return shouldEventsEndEarly ?? DEFAULT_SHOULD_EVENT_END_EARLY_FALLBACK;
};
